/* Store initialization */
export const MAP_API = 'MAP_API'
export const SET_SENTRY_DSN = 'SET_SENTRY_DSN'
export const SET_APP_ENVIRONMENT = 'SET_APP_ENVIRONMENT'
export const SET_APP_READY = 'SET_APP_READY'
